module.exports = __webpack_public_path__ + "img/splashLogo.23692d77.png";